import { useContext } from "react"
import { IndicacoesAmigosContext } from "./IndicacoesAmigosContext"

export function useIndicacoesAmigosContext() {
    return useContext(IndicacoesAmigosContext)
}
